"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalNote = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InternalNote = typebox_1.Type.Object({
    timestamp: typebox_1.Type.String(), // Technically JSON doesn't support dates, except as ISO8601 strings
    note: typebox_1.Type.String(),
    userID: typebox_1.Type.String(),
});
//# sourceMappingURL=internal-note.js.map